<template>

<b-col cols="12">  
  <b-tabs nav-wrapper-class="col-12" v-if="isAndroid">
    <b-tab title="Javascript" active>
      <VisualizationToolJS></VisualizationToolJS>
    </b-tab>
    <b-tab title="Android (Kotlin)">
      <VisualizationToolExo></VisualizationToolExo>
    </b-tab>
    <b-tab title="Android (Java)">
      <VisualizationToolExoJava></VisualizationToolExoJava>
    </b-tab>
  </b-tabs>  

  <VisualizationToolJS v-if="!isAndroid"></VisualizationToolJS>
</b-col>

  

</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import VisualizationToolJS from './VisualizationToolJS.vue';
import VisualizationToolExo from './VisualizationToolExo.vue';
import VisualizationToolExoJava from './VisualizationToolExoJava.vue';
import 'prismjs/themes/prism-twilight.css';
import ClientService from '@/services/client.service'
var clientService = new ClientService()
export default {
  name: 'VisualizationTool',
  data: function() {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      isAndroid: false,
        line1_script: '<script src="https://files.quanteec.com/vizualisation/latest/quanteec-visualize.min.js"><'+'/script>',
        line2_script: '<div id="quanteec-visualize-tool"></div>',
        line3_script: '<div id="quanteec-visualize-tool" style="font-size: 10px;"></div>',
        line4_script: '<div id="quanteec-visualize-tool" quanteecShow="less"></div>',
        bookmarklet: 'javascript:(function(){var t=document.getElementById("quanteec-visualize-tool");if(t) {t.remove();var x=document.getElementById("quanteec-tool-script");if (x){x.remove()};}else{var e=document.createElement("script");t=document.createElement("div"),e.src="https://files.quanteec.com/visualization/latest/quanteec-visualize.min.js",e.setAttribute("id","quanteec-tool-script");t.setAttribute("id","quanteec-visualize-tool"),t.style.padding="10px",t.style.position="fixed",t.style.bottom="0%",t.style.right="0%",t.style.width="100%",t.style.height="70%",t.style.maxWidth="621px",t.style.maxHeight="500px",t.style.backgroundColor="rgba(255,255,255,0.7)",    t.style.zIndex="2147483647",document.body.appendChild(e),document.body.appendChild(t)}})();'
    }
  },
  components: {
      VueMarkdown,
      VisualizationToolJS,
      VisualizationToolExo,
      VisualizationToolExoJava
  },
  beforeMount: function(){
    this.getAndroid();
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeout);
      } catch(err) {}
    },
    copyToClipboard(text) {
      this.cleanMyTimeout();
      this.$copyText(text);
      this.showModal("copied");
      this.timeout = setTimeout(this.hideModal, 1.5 * 1000, 'copied');
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },    
    getAndroid()
    {
      if (this.$auth.getMyUser().roles.indexOf('admin') > -1) {
        clientService.getClient(this.clientView,this.$auth.token()).then(clientRes => {
          if(!clientRes.android)
          {
            this.isAndroid = false;
          } else if(clientRes.android)
          {
            this.isAndroid = true;
          }

        }).catch(err => {
          console.log(err);
        })
      } else {
        this.isAndroid = (this.$auth.getMyUser().client_infos[0].android === true)
      }
      

      
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>